import React from "react";

import Layout from "./Hoc/Layout";

import Home from "./components/home";
import Product from "./components/Product";
import AllProducts from "./components/AllProducts";
import SignIn from "./components/sign_in";
import AddProduct from "./components/Product/AddProduct";
import EditProduct from "./components/Product/EditProduct";
import Udilishea from "./components/AllProducts/Udilishea";
import Catushki from "./components/AllProducts/Catushki";
import Najivki from "./components/AllProducts/Najivki";
import Odejda from "./components/AllProducts/Odejda";
import Podsaki from "./components/AllProducts/Podsaki";
import Snasti from "./components/AllProducts/Snasti";
import Prikormka from "./components/AllProducts/Prikormka";
import Primanki from "./components/AllProducts/Primanki";
import Podstavki from "./components/AllProducts/Podstavki";
import Sumki from "./components/AllProducts/Sumki";
import Snareajenie from "./components/AllProducts/Snareajenie";
import Conatects from "./components/Contact";

import PrivateRoute from "./components/authRoutes/PrivateRoutes";
import PublicRoute from "./components/authRoutes/PublicRoutes";

import { Switch } from "react-router-dom";

import NotFound404 from './components/ui/404';

const Routes = props => {
  return (
    <Layout {...props}>
      <Switch>
        <PublicRoute
          {...props}
          path="/"
          exact
          restricted={false}
          component={Home}
        />
        <PublicRoute
          {...props}
          path="/login"
          exact
          restricted={true}
          component={SignIn}
        />

        <PublicRoute
          {...props}
          path="/products/Продукты"
          exact
          restricted={false}
          component={AllProducts}
        />
        <PublicRoute
          {...props}
          path="/products/Удилища"
          exact
          restricted={false}
          component={Udilishea}
        />
        <PublicRoute
          {...props}
          path="/products/Катушки"
          exact
          restricted={false}
          component={Catushki}
        />

        <PublicRoute
          {...props}
          path="/products/Наживки"
          exact
          restricted={false}
          component={Najivki}
        />

        <PublicRoute
          {...props}
          path="/products/Одежда"
          exact
          restricted={false}
          component={Odejda}
        />

        <PublicRoute
          {...props}
          path="/products/Подсаки"
          exact
          restricted={false}
          component={Podsaki}
        />

        <PublicRoute
          {...props}
          path="/products/Снасти"
          exact
          restricted={false}
          component={Snasti}
        />

        <PublicRoute
          {...props}
          path="/products/Прикормки"
          exact
          restricted={false}
          component={Prikormka}
        />

        <PublicRoute
          {...props}
          path="/products/Приманки"
          exact
          restricted={false}
          component={Primanki}
        />

        <PublicRoute
          {...props}
          path="/products/Подставки"
          exact
          restricted={false}
          component={Podstavki}
        />

        <PublicRoute
          {...props}
          path="/products/Сумки"
          exact
          restricted={false}
          component={Sumki}
        />

        <PublicRoute
          {...props}
          path="/products/Снаряжение"
          exact
          restricted={false}
          component={Snareajenie}
        />

        <PublicRoute
          {...props}
          path="/products/:id"
          exact
          restricted={false}
          component={Product}
        />
        <PrivateRoute
          {...props}
          path="/products/:id/add"
          exact
          component={AddProduct}
        />
        <PrivateRoute
          {...props}
          path="/products/:id/edit"
          exact
          component={EditProduct}
        />

        <PublicRoute
          {...props}
          path="/contacts"
          exact
          restricted={false}
          component={Conatects}
        />

        <PublicRoute
          {...props}
          restricted={false}
          component={NotFound404}
          status={404}
        />
      </Switch>
    </Layout>
  );
};



export default Routes;
